import type { ValueOf } from '#layers/base/public';

/**
 * Output format family for a rendered date/time value, independent of the locale date/time styles.
 * `technical` renders the precise, sortable representation (e.g. `2026-07-06 17:49:10`).
 */
export const DateTimeFormat = {
	Localized: 'localized',
	Technical: 'technical',
} as const;

export type DateTimeFormat = ValueOf<typeof DateTimeFormat>;

export const DATE_TIME_DISPLAY_MODE_OPTIONS = [
	{ value: 'absolute', label: '$t:blocks.date_time_display_options.display_mode.absolute' },
	{ value: 'relative', label: '$t:blocks.date_time_display_options.display_mode.relative' },
] as const;

export const DATE_TIME_DISPLAY_MODE_VALUES = DATE_TIME_DISPLAY_MODE_OPTIONS.map((option) => option.value);
export type DateTimeDisplayMode = typeof DATE_TIME_DISPLAY_MODE_OPTIONS[number]['value'];

export const DATE_DISPLAY_FORMAT_OPTIONS = [
	{ value: 'short', label: '$t:blocks.date_time_display_options.format.short', description: '$t:blocks.date_time_display_options.date_format.options.short.description' },
	{ value: 'medium', label: '$t:blocks.date_time_display_options.format.medium', description: '$t:blocks.date_time_display_options.date_format.options.medium.description' },
	{ value: 'long', label: '$t:blocks.date_time_display_options.format.long', description: '$t:blocks.date_time_display_options.date_format.options.long.description' },
	{ value: 'full', label: '$t:blocks.date_time_display_options.format.full', description: '$t:blocks.date_time_display_options.date_format.options.full.description' },
] as const;

export const TIME_DISPLAY_FORMAT_OPTIONS = [
	{ value: 'short', label: '$t:blocks.date_time_display_options.format.short', description: '$t:blocks.date_time_display_options.time_format.options.short.description' },
	{ value: 'medium', label: '$t:blocks.date_time_display_options.format.medium', description: '$t:blocks.date_time_display_options.time_format.options.medium.description' },
] as const;

export const DATE_TIME_DISPLAY_FORMAT_VALUES = DATE_DISPLAY_FORMAT_OPTIONS.map((option) => option.value);
export type DateTimeDisplayFormat = typeof DATE_DISPLAY_FORMAT_OPTIONS[number]['value'];
export const TIME_DISPLAY_FORMAT_VALUES = TIME_DISPLAY_FORMAT_OPTIONS.map((option) => option.value);
export type TimeDisplayFormat = typeof TIME_DISPLAY_FORMAT_OPTIONS[number]['value'];
